(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebook-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-ebook-preview]').forEach(function(root) {
    var slides = root.querySelectorAll('[data-ebook-preview-slide]');
    if (!slides.length) return;

    var index = 0;
    var show = function(i) {
      slides.forEach(function(slide, idx) {
        slide.classList.toggle('is-active', idx === i);
      });
    };

    var prevBtn = root.querySelector('[data-ebook-preview-prev]');
    var nextBtn = root.querySelector('[data-ebook-preview-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        index = (index - 1 + slides.length) % slides.length;
        show(index);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        index = (index + 1) % slides.length;
        show(index);
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-custom"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sliders = document.querySelectorAll('[data-hero-slider]');
  if (!sliders.length) return;

  sliders.forEach(function(slider) {
    var track = slider.querySelector('.gh-hero-slider__track');
    var slides = slider.querySelectorAll('.gh-hero-slide');
    var dots = slider.querySelectorAll('.gh-hero-slider__dot');
    if (!track || !slides.length) return;

    var index = 0;
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = parseInt(slider.dataset.speed || '6000', 10);
    var timer;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      var offset = -index * 100;
      track.style.transform = 'translateX(' + offset + '%)';

      if (dots.length) {
        dots.forEach(function(dot) { dot.classList.remove('is-active'); });
        if (dots[index]) dots[index].classList.add('is-active');
      }
    }

    function start() {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(function() {
        goTo(index + 1);
      }, speed);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    if (dots.length) {
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var i = parseInt(dot.getAttribute('data-hero-dot') || '0', 10);
          goTo(i);
          start();
        });
      });
    }

    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    goTo(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
